<div class="w100 align-center space-between row">
  <h2>Tracks</h2>
  <div class="row gap-8 align-center">
    <rr-btn type="Link" (click)="newTrack()">Add Track</rr-btn>
  </div>
</div>

<div class="tracklist w100">
  @for(track of tracks; track track.id){
  <div class="trackwrapper w100">
    <div class="row space-between align-center">
      <div class="trackname grow-1">
        {{ track.name || track.streams[0]?.name }}
      </div>
      <div class="row gap-24 align-center">
        <rr-icon
          name="edit"
          color="nutral"
          class="pointer"
          (click)="editTrack(track)"
        ></rr-icon>
        <rr-icon
          name="trash"
          color="nutral"
          class="pointer"
          (click)="deleteTrack(track)"
        ></rr-icon>
        <rr-btn size="medium" (click)="openPromo(track)" type="Secondary"
          >Promo Link</rr-btn
        >
        <rr-btn
          type="Secondary"
          size="medium"
          iconStart="add"
          (click)="newStream(track)"
          >Add Stream</rr-btn
        >
      </div>
    </div>
    <rr-track [track]="track" (delete)="deleteTrack($event)"></rr-track>
  </div>
  }
</div>

<rr-spinner *ngIf="!hidespinner"></rr-spinner>
